/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const setDefaultSocietaRequestSchema = z.object({
  societaId: z.coerce.number().int().nullable(),
});
